import api from "@/requests";
import { fetchRedModel } from "@/api/dashboard";

export default {
  namespaced: true,
  state: {
    selectedBill: null,
    billDetails: null,
    redModel: null,
    prepaymentTable: null,
  },
  mutations: {
    SET_RED_MODEL: (state, redModel) => {
      state.redModel = redModel;
    },
    SET_SELECTED_BILL: (state, data) => (state.selectedBill = data),
    SET_BILL_DETAILS: (state, data) => (state.billDetails = data),
    SET_PREPAYMENT_TABLE: (state, data) => (state.prepaymentTable = data)
  },
  getters: {
    redModel(state) {
      return state.redModel
    },
    getSelectedBill: (state) => {
      return state.selectedBill;
    },
    getBillDetails: (state) => {
      return state.selectedBill ?? state.billDetails;
    },
    prepaymentTable: (state) => (state.prepaymentTable)
  },
  actions: {
    async getRedModel({ commit }, showLoader) {
      const data = await fetchRedModel(showLoader);
      commit("SET_RED_MODEL", data);
      return data;
    },
    async fetchSelectedBill({ commit }, simpleId, selectedDate) {
      const data = await api.post("/api/v1/MyRed/bills", {
        redSimpleId: simpleId,
        shouldFetchPaidBills: true,
        beginDate: "01.01.2016",
        endDate: this.$filter.formatDate(new Date(), "DD MMMM YYYY"),
      });
      commit(
        "SET_SELECTED_BILL",
        data.filter(
          (bl) =>
            bl.status == "PAID" &&
            this.$filter.formatDate(bl.pay_until_date, "DD.MM.YYYY") ==
              selectedDate
        )[0]
      );
    },
    async fetchBillDetails({ commit }, { simpleId, billNum }) {
      const data = await api.post("/api/v1/MyRed/BillDetails", {
        redSimpleId: simpleId,
        selectedBillNum: billNum,
      });
      commit("SET_BILL_DETAILS", data);
    },
    async setSelectedBill({ commit }, selectedBill) {
      commit("SET_SELECTED_BILL", selectedBill);
    },
  },
};
